import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Ticket, TicketComment, User } from './support_sdk/_internal';
import { ITEM_COMMON_MODULE_IMPORTS } from '@galaxy/inventory-ui';

@Component({
  selector: 'app-support-dialog',
  styleUrls: ['./support-ticket-dialog.component.scss'],
  template: `
    <h2 mat-dialog-title>{{ ticket.subject }}</h2>
    <div class="ticket-info">
      <span>{{ ticket.createdAt | date: 'short' }}</span>
      <span>{{ ticket.requester.name }}</span>
      <span *ngIf="ticket.requester.email"><{{ ticket.requester.email }}></span>
      <span>via {{ ticket.via.channel }}</span>
      <span *ngIf="ticket.recipient"><{{ ticket.recipient }}></span>
    </div>
    <mat-dialog-content>
      <div class="comments" [ngClass]="{ private: !comment.public }" *ngFor="let comment of ticketComments">
        <span class="name">{{ getUser(comment.authorId)?.name }}</span>
        <span class="created-at">{{ comment.createdAt | date: 'short' }}</span>
        <div [innerHtml]="comment.htmlBody"></div>
      </div>
    </mat-dialog-content>
  `,
  imports: [ITEM_COMMON_MODULE_IMPORTS],
})
export class SupportTicketDialogComponent {
  ticket: Ticket;
  ticketComments: TicketComment[];
  users: User[];

  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {
    this.ticket = data.ticket;
    this.ticketComments = data.ticketComments;
    this.users = data.users;
  }

  getUser(id: number): User {
    for (let i = 0; i < this.users.length; i++) {
      if (Number(this.users[i].id) === id) {
        return this.users[i];
      }
    }
  }
}
